import { Link, Text } from "@simplybusiness/mobius";
import type { WithMetadata } from "../../pages";
import type { RewardBannerProps } from "./types";
import classNames from "classnames/dedupe";

export const RewardBanner = (props: WithMetadata<RewardBannerProps>) => {
  const {
    componentName,
    description,
    termsUrl,
    code,
    referAFriendId,
    variant,
    ...otherProps
  } = props;

  const classes = classNames(
    "mobius",
    "mobius-reward-banner",
    variant === "voucher" && "--is-voucher",
    variant === "raf" && "--is-raf",
  );

  return (
    <div
      className={classes}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
    >
      <div className="mobius-reward-banner__body">
        {variant === "voucher" && (
          <>
            <Text variant="small">
              {description}.{" "}
              <Link href={termsUrl} target="_blank" rel="noopener noreferrer">
                View terms
              </Link>
            </Text>
            <Text variant="small">
              Voucher applied <strong>{code}</strong>
            </Text>
          </>
        )}

        {variant === "raf" && (
          <>
            <Text variant="small">
              Voucher applied <strong>{code}</strong>
            </Text>
            <Text variant="small">
              Referrer <strong>{referAFriendId}</strong>
            </Text>
          </>
        )}
      </div>
    </div>
  );
};
